<script lang="ts">
import { Tooltip } from '@cf/ui-lib';
import FiEdit from '../../../../assets/svg/FiEdit.svelte';
import LiaClone from '../../../../assets/svg/LiaClone.svelte';
import RiDeleteBinLine from '../../../../assets/svg/RiDeleteBinLine.svelte';
import { BsThreeDots } from '@cf/ui-lib/icons';

export let id: string = '';
export let onDomainRemove = (id: string) => {};
</script>

<Tooltip id={id}  isCloseOnOutsideClick={true}>
	<ul class="grid list-none gap-[20px]" slot="tooltip-list">
		<li class="flex items-center gap-[10px]">
			<a class="flex items-center gap-[10px]" href={`/uilib/domains/details/edit/${id}`}>
				<FiEdit />
				<p>Edit</p>
			</a>
		</li>
		<li class="flex items-center gap-[10px]"  >
			<a class="flex items-center gap-[10px]" href={`/uilib/domains/details/clone/${id}`}>
				<LiaClone />
				<p>Clone</p>
			</a>
		</li>
		<li><div class="h-[1px] w-full bg-[#E7E7E7]"></div></li>
		<!-- <li class="flex items-center gap-[10px]">
			<Fisuspect />
			<p>Mark Suspect</p>
		</li>
		<li class="flex items-center gap-[10px]">
			<MarkApproved />
			<p>Mark Approved</p>
		</li>
		<li class="flex items-center gap-[10px]">
			<FiIgnored />
			<p>Mark Ignored</p>
		</li> -->
		<li class="flex items-center cursor-pointer gap-[10px]" on:click={()=>onDomainRemove(id)}>
			<RiDeleteBinLine />
			<p>Remove</p>
		</li>
	</ul>
	<BsThreeDots slot="button-details"></BsThreeDots>
</Tooltip>
